import axios from 'axios';

// Локально (npm start): .env.development → http://127.0.0.1:8000
// Production-сборка (npm run build / Docker): .env.production → http://95.84.210.60:9091
// Переопределение: REACT_APP_API_URL в окружении или .env.local
// export const API_URL ='http://127.0.0.1:8000'
// export const API_URL ='http://95.84.210.60:9091'
export const API_URL ='https://back.go-bananas.ru'


// Создаем экземпляр axios с базовой конфигурацией
const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Добавляем перехватчик для установки токена авторизации
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Добавляем перехватчик для обработки ошибок
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Если токен истек или недействителен, очищаем localStorage и перенаправляем на страницу входа
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export { axiosInstance };
